import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { Location } from '@angular/common';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, Params } from '@angular/router';

import 'rxjs/add/observable/of';

import { OpcionModel } from '../Global/Opcion.model';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import * as sucursalModel from './Sucursal.model';
import { ConfirmarEliminacionService } from '../Dialog/ConfirmarEliminacionService';



@Component({
	selector : 'sucursal',
	templateUrl : './SucursalIndex.component.html',
	styleUrls  : ['../../../../styles.css']
})


export class SucursalIndexComponent {
	
	// ~~~~~ Variables para el manejo de permisos ~~~~~ //
	public btnAgregar:boolean;
	public btnEditar:boolean;
	public btnEliminar:boolean;
	public btnConsultar:boolean;
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

	public registroTercero;
	public guardando:boolean;
	public tercero:string;
	public displayedColumns;
	public dataSource;

	public ocultar: boolean = false;
	public mensaje: string = "";

	public sucursales:Array<sucursalModel.SucursalModel>;


	constructor(private _serviciosGenerales:ServiciosGenerales, public snackBar: MatSnackBar, 
		private _route: ActivatedRoute, private _router:Router,private _location: Location,
		private confirmarEliminacionService:ConfirmarEliminacionService)
	{

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnAgregar = _serviciosGenerales.seguridad.isAgregar();
		this.btnEditar = _serviciosGenerales.seguridad.isEditar();
		this.btnEliminar = _serviciosGenerales.seguridad.isEliminar();
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.snackBar.dismiss();
		
		this.sucursales = new Array();
		this.displayedColumns = ['vsucursal','vdireccion','vtelefono','vciudad','opciones'];
		this.dataSource = new ExampleDataSource(null);
	}

	

	ngOnInit(){
		this._route.params.subscribe( params =>{
			this.registroTercero = [{'cnumcont':params['cnumcont'], 
			'ctipid' :params['ctipid'], 
			'cnumid' :params['cnumid'],
			'vnombre':params['vnombre'],
			'desde'  :params['desde']}];
		})



		this.cargarInfo(this.registroTercero);
		this.dataSource = new ExampleDataSource(this.sucursales);
	}


	cargarInfo(registroTercero){

		this.tercero = this.registroTercero[0].vnombre;
		this.dataSource = new ExampleDataSource(null);	
		this.sucursales = new Array();
		
		this._serviciosGenerales.get('sucursales', {cnumcont:this.registroTercero[0].cnumcont, ctipid:this.registroTercero[0].ctipid, cnumid:this.registroTercero[0].cnumid}).subscribe(result =>{
			
			for(let x of result){
				console.log(x, '<----');
				this.sucursales.push(new sucursalModel.SucursalModel( 
					new sucursalModel.MchSucursalesId(this.registroTercero[0].cnumcont, 
						this.registroTercero[0].ctipid, 
						this.registroTercero[0].cnumid,
						x.cidregter),
					x.vdireccion,x.vtelefono,
					new sucursalModel.DefCiudades(new sucursalModel.DefCiudadesId(x.codciudad, x.coddepto.trim(),x.ccodigopais), x.vciudad),
					/*new sucursalModel.DefDepartamentos(x.vdepto,x.coddepto),
					new sucursalModel.DefCiudades(x.vciudad,x.codciudad), 					*/
					x.vcorreo,0,0,0,0, '','',''
					));
			};
			console.log(this.sucursales);
			this.dataSource = new ExampleDataSource(this.sucursales);
			
		}, 

		error =>{
			var errorMensaje = <any>error;
			console.log('Error al enviar la peticion ', errorMensaje);
			this.openSnackBarEspecial("Ocurrió un error al momento de cargar las sucursales asociadas", "X");

		});


	}

	openSnackBar(message: string, action: string)
	{
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}


	editarRegistro(registro){
console.log("----------------------------------------------------------->");
console.log(registro);

		this._router.navigate(['/Sucursal',
			registro.id.cnumcont,
			registro.id.ctipid,
			registro.id.cnumid,
			this.registroTercero[0].vnombre,
			registro.id.cidregter,			
			this.registroTercero[0].desde,			
			'actualizar']);
	}

	agregar(){

		console.log(this.registroTercero);
		this._router.navigate(['/Sucursal',
			this.registroTercero[0].cnumcont,
			this.registroTercero[0].ctipid,
			this.registroTercero[0].cnumid,
			this.registroTercero[0].vnombre,
			' ',
			this.registroTercero[0].desde,
			'insertar']);	
	}
	
	eliminarRegistro(registro){

		console.log(registro);
		console.log({cnumcont:registro.id.cnumcont,ctipid:registro.id.ctipid,cnumid:registro.id.cnumid, cidregter:registro.id.cidregter, vsucursal:registro.id.cidregter});
		this.confirmarEliminacionService.abrirDialog({cnumcont:registro.id.cnumcont,ctipid:registro.id.ctipid,cnumid:registro.id.cnumid, cidregter:registro.id.cidregter}, 'eliminarSucursal');
		this.confirmarEliminacionService.eventoFin$.subscribe(r=>{
			this.cargarInfo(this.registroTercero);
		});
	}

	 backClicked() {
        this._location.back();
    }


	openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {
			console.log("Paso por aqui 1 notas");

			this.ocultar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		
		if (shand.length != 0) {
			    for (let i=0;i<shand.length;i++){
				shand[i].style.backgroundColor = "rgb(255 204 214)";
				}
			}
	}

}


export class ExampleDataSource {

	public data: Array<sucursalModel.SucursalModel>;
	

	constructor(sucursal:Array<sucursalModel.SucursalModel>){
		this.data = new Array();
		
		
		if(sucursal != null){
			for(let i of sucursal){
				this.data.push(i);
			}

			console.log(this.data);
		}
	}

	/** Connect function called by the table to retrieve one stream containing the data to render. */
	connect(): Observable<sucursalModel.SucursalModel[]>
	{
		return Observable.of(this.data);
	}

	disconnect()
	{
	}
}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Tercero/SucursalIndex.component.ts